module.exports = __webpack_public_path__ + "img/1505581618.9d9ec287.jpg";